/**
 * Compact section-title style shared across the RO details panel (Jobs, Notes,
 * RO Report). Kept in one place so the sections don't drift when the design
 * changes.
 */
export const RO_SECTION_TITLE_CLASS =
  "text-[13px] font-bold leading-none tracking-normal text-slate-900";
